import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  constructor() { }

    private darkModeKey = 'darkMode';
      readonly darkMode$ = new BehaviorSubject<boolean>(this.getCurrentMode());


  setDarkMode(isDark: boolean): void {
    const html = document.documentElement;
    html.classList.toggle('my-app-dark', isDark);
    localStorage.setItem(this.darkModeKey, isDark ? 'true' : 'false');
    this.darkMode$.next(isDark);
  }

  loadTheme(): void {
    const isDark = localStorage.getItem(this.darkModeKey) === 'true';
    const html = document.documentElement;
    html.classList.toggle('my-app-dark', isDark);
    this.darkMode$.next(isDark);
  }

  getCurrentMode(): boolean {
    return localStorage.getItem(this.darkModeKey) === 'true';
  }

  toggleDarkMode(): boolean {
    const current = this.getCurrentMode();
    const newMode = !current;
    this.setDarkMode(newMode);
    return newMode;
  }
}
